import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IIntegrationLogSearchDto, IntegrationLogsLogicService } from '@app/logic/integration-logs';
import { SearchIndexesLogicService } from '@app/logic/search-indexes/search-indexes.logic.service';
import { CbDialogService } from '@app/shared/components/dialog/cb-dialog.service';
import { ISearchResult } from '@app/shared/components/search/i.search';
import { SEARCH_INDEX_ENUM } from '@classictechsolutions/hubapi-transpiled-enums';
import {isNullOrWhiteSpace, ITableColumn} from 'cb-hub-lib';
import { BehaviorSubject, debounceTime, defaultIfEmpty, filter, Observable, startWith, Subject, Subscription, take } from 'rxjs';
import { ExceptionLogViewDialogComponent } from '../exception-log-view-dialog/exception-log-view-dialog.component';


@Component({
    selector: 'cb-contact-integration-exception-logs',
    templateUrl: './contact-integration-exception-logs.component.html',
    styleUrls: ['./contact-integration-exception-logs.component.scss'],
    standalone: false
})
export class ContactIntegrationExceptionLogsComponent implements OnInit {

    public searchText = new UntypedFormControl();
    public dateFrom: string;
    public dateTo: string;

    public infiniteScrollEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public logs: IIntegrationLogSearchDto[] = [];
    public currentPage: number;
    public readonly queryUpdated = new Subject();

    public readonly subscriptions$ = new Subscription();

    public readonly isNullOrWhiteSpace = isNullOrWhiteSpace;

    public readonly columns: ITableColumn[] = [
        { label: 'Datetime', width: 150 },
        { label: 'Instance ID', width: 150 },
        { label: 'Instance IP', width: 150 },
        { label: 'Source' },
        { label: 'Details' },
        { label: '' },
    ];

    constructor(
        private readonly integrationLogsLogic: IntegrationLogsLogicService,
        private readonly cbDialog: CbDialogService,
        private readonly searchIndexesLogic: SearchIndexesLogicService,
    ) { }

    public ngOnInit(): void {
        this.createSearchTextSub();
    }

    public ngOnDestroy(): void {
        this.subscriptions$.unsubscribe();
    }

    public clearFilters(): void {
        this.dateFrom = null;
        this.dateTo = null;
        this.searchText.setValue('');
    }

    public cleanSearch(): void {
        this.infiniteScrollEnabled.next(true);
        this.queryUpdated.next(null);
    }

    public clearDateTo(): void {
        this.dateTo = null;
        this.cleanSearch();
    }

    public clearDateFrom(): void {
        this.dateFrom = null;
        this.cleanSearch();
    }

    public search(): Observable<ISearchResult<IIntegrationLogSearchDto>> {
        const params = {
            currentpage: this.currentPage,
            query: this.searchText.value ?? '',
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
        };
        return this.integrationLogsLogic
            .searchContactIntegrationExceptionLogs(params);
    }

    public viewExceptionLog(log: IIntegrationLogSearchDto): void {
        this.cbDialog.open(ExceptionLogViewDialogComponent, {
            data: {
                log
            },
            minWidth: '40%',
        });
    }

    public reindexLogs(): void {
        const ref = this.cbDialog.block('Fetching Latest Logs...');
        this.searchIndexesLogic.reindex(SEARCH_INDEX_ENUM.ContactIntegrationLogs).pipe(take(1)).subscribe(() => {
            setTimeout(() => {
                ref.close();
                this.cleanSearch();
            }, 1000);
        });
    }

    private createSearchTextSub(): void {
        this.subscriptions$.add(
            this.searchText.valueChanges
                .pipe(
                    defaultIfEmpty(''),
                    startWith(''),
                    debounceTime(400),
                    filter(q => typeof q === 'string')
                )
                .subscribe(() => {
                    this.cleanSearch();
                })
        );
    }

}
